__turbopack_context__.v({
  "card": "AVCrkq_card",
  "cards": "AVCrkq_cards",
  "cta": "AVCrkq_cta",
  "empty": "AVCrkq_empty",
  "eyebrow": "AVCrkq_eyebrow",
  "filters": "AVCrkq_filters",
  "heading": "AVCrkq_heading",
  "inner": "AVCrkq_inner",
  "media": "AVCrkq_media",
  "pager": "AVCrkq_pager",
  "price": "AVCrkq_price",
  "section": "AVCrkq_section",
});
